import { useCallback, useEffect, useState } from 'react';
import { Alert, Box, CircularProgress, Tab, Tabs } from '@mui/material';

import PageHeader from '../../components/PageHeader/PageHeader';
import AssistantChat from './AssistantChat';
import AssistantSettingsPanel from './AssistantSettingsPanel';
import { assistantErrorMessage, getAssistantStatus } from '../../services/AssistantService';
import { getStoredPermissions } from '../../utils/dashboardPermissions';
import { permissionOptions } from '../../utils/Enums';

const idOf = (label) => permissionOptions.find((permission) => permission.label === label)?.id;

export default function AssistantPage() {
  const permissions = getStoredPermissions();
  const canManage = permissions.includes(idOf('MANAGE_AI_ASSISTANT'));
  const [tab, setTab] = useState('chat');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState('');

  const loadStatus = useCallback(async () => {
    try {
      setStatus(await getAssistantStatus());
      setError('');
    } catch (e) {
      setError(assistantErrorMessage(e));
    }
  }, []);

  useEffect(() => { loadStatus(); }, [loadStatus]);

  return (
    <Box p={3}>
      <PageHeader title="Asistente" subtitle="Preguntale a tus datos: ventas, stock, costos y más" />

      {canManage && (
        <Tabs value={tab} onChange={(_, value) => setTab(value)} sx={{ mb: 2 }}>
          <Tab value="chat" label="Chat" />
          <Tab value="settings" label="Configuración" />
        </Tabs>
      )}

      {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
      {!status && !error && <CircularProgress size={24} />}

      {status && tab === 'chat' && (
        <AssistantChat status={status} canManage={canManage} onOpenSettings={() => setTab('settings')} />
      )}
      {tab === 'settings' && canManage && <AssistantSettingsPanel onChanged={loadStatus} />}
    </Box>
  );
}
